<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'
import { mapGetters } from 'vuex'


export default {
  components: { NavBar, SideBar, RightBar },

  // props: {
  //   hideAll:{
  //     type: Boolean,
  //     default: false,
  //   }
  // },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  computed: {
    ...mapGetters({
      session: 'auth/currentSession',
    }),
    isPublicProject(){
      return this.session && this.session.publicProject
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      if (
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
          navigator.userAgent
        )
      ){
        document.body.classList.toggle('enlarged')
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    }
  }
  // mounted: function(){
    // this.toggleMenu()
    // if (localStorage.getItem('isMenuCondensed') === 'true'){
    //   this.toggleMenu()
    // }
  // }
}
</script>

<template>
  <div id="wrapper">
    Menu condensed? {{ isMenuCondensed }}
    <NavBar :user="user" :toggle-menu="toggleMenu" />
    <SideBar v-if="!isPublicProject" :is-condensed="isMenuCondensed" />
    <div :class="isPublicProject ? 'margin-top-70' : 'content-page'">
      <div class="">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
    </div>
    <RightBar v-if="!isPublicProject" />
  </div>
</template>

<style scoped>
.margin-top-70{
  margin-top: 70px;
}
</style>